import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_5 = {
  class: "data-table-body"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "data-table-td"
};
const _hoisted_8 = {
  class: "font-medium text-slate-800"
};
const _hoisted_9 = {
  class: "data-table-td"
};
const _hoisted_10 = {
  class: "text-xs text-slate-500 line-clamp-2 max-w-[360px] inline-block"
};
const _hoisted_11 = {
  class: "data-table-td is-center"
};
const _hoisted_12 = {
  class: "data-table-td is-center"
};
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "text-xs"
};
const _hoisted_15 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_16 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
import { ref, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { usePagination } from '@/composables/usePagination';
import { useSearch } from '@/composables/useSearch';
import { getPortalFaqPage, getPortalFaqDetail, createPortalFaq, updatePortalFaq, deletePortalFaq } from '@/api/portal';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import FaqFormModal from './components/FaqFormModal.vue';

// 数据

export default {
  __name: 'PortalFaqManagement',
  setup(__props) {
    const loading = ref(false);
    const faqList = ref([]);

    // 分页
    const {
      pagination,
      goToPage,
      setPageSize,
      updatePagination
    } = usePagination({
      pageSize: 10
    });

    // 搜索
    const {
      searchForm,
      resetSearch,
      getSearchParams
    } = useSearch({
      initialForm: {
        status: ''
      },
      onSearch: fetchData
    });

    // 表单窗口
    const showFormModal = ref(false);
    const isEdit = ref(false);
    const editFaqData = ref(null);
    const formModalRef = ref();

    // 状态选项
    const statusOptions = [{
      label: '全部状态',
      value: ''
    }, {
      label: '启用',
      value: 1
    }, {
      label: '停用',
      value: 0
    }];

    // 状态配置
    const statusConfig = {
      0: {
        label: '停用',
        dot: 'bg-red-400',
        bg: 'bg-red-100',
        text: 'text-red-700'
      },
      1: {
        label: '启用',
        dot: 'bg-green-500',
        bg: 'bg-green-100',
        text: 'text-green-700'
      }
    };

    // 获取数据（分页参数沿用 pageNum/pageSize，与门户文章保持一致）
    async function fetchData() {
      loading.value = true;
      try {
        const params = {
          ...getSearchParams(),
          pageNum: pagination.current,
          pageSize: pagination.size
        };
        const data = await getPortalFaqPage(params);
        faqList.value = data.records || [];
        updatePagination(data);
      } catch (error) {
        ElMessage.error('加载FAQ列表失败');
        console.error('加载FAQ列表失败:', error);
      } finally {
        loading.value = false;
      }
    }

    // 筛选变化
    const handleFilterChange = () => {
      pagination.current = 1;
      fetchData();
    };

    // 换页
    const changePage = page => {
      goToPage(page);
      fetchData();
    };

    // 切换每页条数
    const changePageSize = size => {
      setPageSize(size);
      fetchData();
    };

    // 格式化时间
    const formatTime = time => {
      if (!time) return '-';
      return String(time).replace('T', ' ').substring(0, 16);
    };

    // ========== 操作 ==========

    // 新增
    const handleAdd = () => {
      isEdit.value = false;
      editFaqData.value = null;
      showFormModal.value = true;
    };

    // 编辑
    const handleEdit = async item => {
      try {
        const detail = await getPortalFaqDetail(item.id);
        isEdit.value = true;
        editFaqData.value = detail;
        showFormModal.value = true;
      } catch (error) {
        ElMessage.error('获取FAQ详情失败');
      }
    };

    // 表单提交
    const handleFormConfirm = async data => {
      try {
        if (isEdit.value) {
          await updatePortalFaq(data.id, data);
          ElMessage.success('更新FAQ成功');
        } else {
          await createPortalFaq(data);
          ElMessage.success('创建FAQ成功');
        }
        formModalRef.value?.done();
        fetchData();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
        formModalRef.value?.done();
      }
    };

    // 启用/停用（契约无独立状态接口，通过整体更新实现）
    const handleStatusChange = async (item, targetStatus) => {
      const statusText = {
        0: '停用',
        1: '启用'
      };
      try {
        await ElMessageBox.confirm(`确定要${statusText[targetStatus]}此FAQ吗？`, '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        const detail = await getPortalFaqDetail(item.id);
        await updatePortalFaq(item.id, {
          ...detail,
          status: targetStatus
        });
        ElMessage.success('状态更新成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '状态更新失败');
        }
      }
    };

    // 删除
    const handleDelete = async item => {
      try {
        await ElMessageBox.confirm('确定要删除此FAQ吗？删除后无法恢复。', '确认删除', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deletePortalFaq(item.id);
        ElMessage.success('删除成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '删除失败');
        }
      }
    };
    onMounted(() => {
      fetchData();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "text-xl font-semibold text-slate-900"
        }, "门户FAQ管理"), _createElementVNode("p", {
          class: "text-sm text-slate-500 mt-1"
        }, "管理门户网站常见问题内容")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchData
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: handleAdd,
            class: "btn-primary"
          }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增FAQ ", -1)]))])), [[_directive_permission, 'portal:faq:manage']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            onClick: fetchData,
            class: "btn-primary"
          }, " 搜索 "), _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = (...args) => _unref(resetSearch) && _unref(resetSearch)(...args)),
            class: "btn-secondary"
          }, " 重置 ")]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(searchForm).status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchForm).status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, opt => {
              return _createVNode(_component_el_option, {
                key: String(opt.value),
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[11] || (_cache[11] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th"
        }, "问题"), _createElementVNode("th", {
          class: "data-table-th"
        }, "答案"), _createElementVNode("th", {
          class: "data-table-th is-center w-16"
        }, "排序"), _createElementVNode("th", {
          class: "data-table-th is-center w-20"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th w-36"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_5, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[5] || (_cache[5] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-48"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-64"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-8 mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-5 bg-slate-200 rounded w-14 mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-28"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-20 mx-auto"
          })], -1)]))]);
        }), 64)) : _createCommentVNode("", true), !loading.value && faqList.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [...(_cache[6] || (_cache[6] = [_createElementVNode("td", {
          colspan: "6",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "w-8 h-8 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })])]), _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无FAQ数据"), _createElementVNode("p", {
          class: "empty-state-desc"
        }, "点击上方按钮新增FAQ")])], -1)]))])) : _createCommentVNode("", true), !loading.value ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(faqList.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.question || '-'), 1)]), _createElementVNode("td", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(item.answer || '-'), 1)]), _createElementVNode("td", _hoisted_11, _toDisplayString(item.sort ?? '-'), 1), _createElementVNode("td", _hoisted_12, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", [statusConfig[item.status]?.bg, statusConfig[item.status]?.text]])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1.5", statusConfig[item.status]?.dot])
          }, null, 2), _createTextVNode(" " + _toDisplayString(statusConfig[item.status]?.label || '未知'), 1)], 2)]), _createElementVNode("td", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(formatTime(item.createTime)), 1)]), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleEdit(item),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_17)), [[_directive_permission, 'portal:faq:manage']]), item.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleStatusChange(item, 1),
            class: "table-action-button is-success",
            title: "启用",
            "aria-label": "启用"
          }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
          })], -1)]))], 8, _hoisted_18)), [[_directive_permission, 'portal:faq:manage']]) : _createCommentVNode("", true), item.status === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => handleStatusChange(item, 0),
            class: "table-action-button is-teal",
            title: "停用",
            "aria-label": "停用"
          }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
          })], -1)]))], 8, _hoisted_19)), [[_directive_permission, 'portal:faq:manage']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleDelete(item),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_20)), [[_directive_permission, 'portal:faq:manage']])])])]);
        }), 128)) : _createCommentVNode("", true)])])])]), _unref(pagination).total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: _unref(pagination),
          "page-sizes": [10, 20, 50],
          onPageChange: changePage,
          onSizeChange: changePageSize
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(FaqFormModal, {
          ref_key: "formModalRef",
          ref: formModalRef,
          show: showFormModal.value,
          "onUpdate:show": _cache[2] || (_cache[2] = $event => showFormModal.value = $event),
          "is-edit": isEdit.value,
          "faq-data": editFaqData.value,
          onConfirm: handleFormConfirm
        }, null, 8, ["show", "is-edit", "faq-data"])]),
        _: 1
      });
    };
  }
};